import type { OptionSelectInputResources } from '@models/partner/menu/option-select-input-resource';
import type { Observable } from 'rxjs';

import { inject } from '@angular/core';
import { NavigationItemService } from '@features/partners/builder/settings/menu/navigation-item/navigation-item.service';

export const internalRoutesResolver = (): Observable<never[] | OptionSelectInputResources> =>
  inject(NavigationItemService).internalRoutes$;
